import { Routes } from '@angular/router';
import { RoleGuard } from '@guards/role.guard';

const productsModule = () => import('./products.module').then((m) => m.ProductsModule);

export const productRoutes: Routes = [
  {
    path: 'products',
    canActivateChild: [RoleGuard],
    loadChildren: productsModule,
    data: {
      enum: 'PRODUCT_CATALOG',
      label: 'Product Catalog',
      icon: 'ic_package.svg',
      activeClass: 'active',
      path: 'products',
      children: [
        {
          enum: 'LIST_PRODUCT_PUBLISHED',
          label: 'List Products',
          path: 'products/list-published',
          children: [],
        },
        {
          enum: 'LIST_PRODUCT_PUBLISH_REQUEST',
          path: 'products/publish-request',
          label: 'Publish Request',
          children: [],
        },
        {
          enum: 'LIST_QR_PRODUCT',
          path: 'products/list-qr-produk',
          label: 'QR Produk',
          children: [],
        },
      ],
    },
  },
];
